import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_BILLING_PLANS,
  FETCH_BILLING_PLANS_ERROR,
  CLEAR_FETCH_BILLING_PLANS,
  FETCH_STRIPE_SETUP_INTENT,
  FETCH_STRIPE_SETUP_INTENT_ERROR,
  CLEAR_STRIPE_SETUP_INTENT,
  UPDATE_BILLING_PLAN,
  UPDATE_BILLING_PLAN_ERROR,
  CLEAR_UPDATE_BILLING_PLAN,
  UPDATE_BILLING_PLAN_PAYPAL,
  UPDATE_BILLING_PLAN_PAYPAL_ERROR,
  CLEAR_UPDATE_BILLING_PLAN_PAYPAL,
  UPDATE_BILLING_PLAN_CRYPTOCOM,
  UPDATE_BILLING_PLAN_CRYPTOCOM_ERROR,
  CLEAR_UPDATE_BILLING_PLAN_CRYPTOCOM,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_ERROR,
  CLEAR_CANCEL_SUBSCRIPTION,
  RENEW_SUBSCRIPTION,
  RENEW_SUBSCRIPTION_ERROR,
  CLEAR_RENEW_SUBSCRIPTION,
  FETCH_CREDIT_CARD_INFO,
  FETCH_CREDIT_CARD_INFO_ERROR,
  CLEAR_FETCH_CREDIT_CARD_INFO,
  UPDATE_CREDIT_CARD,
  UPDATE_CREDIT_CARD_ERROR,
  CLEAR_UPDATE_CREDIT_CARD,
  VALIDATE_STRIPE_COUPON_SUCCES,
  VALIDATE_STRIPE_COUPON_ERROR,
  CLEAR_VALIDATE_STRIPE_COUPON,
  SET_BILLING_PLAN_SELECTOR_MODE,
  FETCH_BILLING_INVOICES,
  FETCH_BILLING_INVOICES_ERROR,
  CLEAR_FETCH_BILLING_INVOICES,
  FETCH_SINGLE_INVOICE_PDF,
  FETCH_SINGLE_INVOICE_PDF_ERROR,
  CLEAR_FETCH_SINGLE_INVOICE_PDF,
  FETCH_BILLING_INFO,
  FETCH_BILLING_INFO_ERROR,
  CLEAR_FETCH_BILLING_INFO,
  PATCH_BILLING_INFO_SUCCESS,
  PATCH_BILLING_INFO_ERROR,
  CLEAR_PATCH_BILLING_INFO,
  DELETE_PAYMENT_PROVIDER_SUCCESS,
  DELETE_PAYMENT_PROVIDER_ERROR,
  CLEAR_DELETE_PAYMENT_PROVIDER,
  PATCH_PAYMENT_PROVIDER_SUCCESS,
  PATCH_PAYMENT_PROVIDER_ERROR,
  CLEAR_PATCH_PAYMENT_PROVIDER,
  FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK,
  FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK_ERROR,
  CLEAR_PAYMENT_PROVIDER_ONBOARDING_LINK,
} from 'redux/billing/types';

export const fetchBillingPlans = () => baseErrorsHandlerDecorator(
  FETCH_BILLING_PLANS,
  FETCH_BILLING_PLANS_ERROR,
  () => restapi.get(addLang('billing/')),
  false,
);

export const clearFetchBillingPlans = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_BILLING_PLANS,
  });
};

export const createStripeSetupIntent = (
  billingPlanId, interval = null) => baseErrorsHandlerDecorator(
  FETCH_STRIPE_SETUP_INTENT,
  FETCH_STRIPE_SETUP_INTENT_ERROR,
  () => restapi.post(addLang('billing/stripe/create-setup-intent/'), {
    billing_plan_id: billingPlanId, interval,
  }),
);

export const clearStripeSetupIntent = () => dispatch => {
  dispatch({
    type: CLEAR_STRIPE_SETUP_INTENT,
  });
};

export const updateBillingPlan = (
  planId, paymentMethod, interval, coupon) => baseErrorsHandlerDecorator(
  UPDATE_BILLING_PLAN,
  UPDATE_BILLING_PLAN_ERROR,
  () => restapi.post(addLang('billing/'), {
    billing_plan_id: planId,
    payment_method: paymentMethod,
    interval: interval,
    coupon: coupon,
  }),
);

export const clearUpdateBillingPlan = () => dispatch => {
  dispatch({
    type: CLEAR_UPDATE_BILLING_PLAN,
  });
};

export const updateBillingPlanPaypal = (subscriptionData, planId, interval) => baseErrorsHandlerDecorator(
  UPDATE_BILLING_PLAN_PAYPAL,
  UPDATE_BILLING_PLAN_PAYPAL_ERROR,
  () => restapi.post(addLang('billing/paypal/'), {
    subscription_data: subscriptionData,
    billing_plan_id: planId,
    interval: interval,
  }),
);

export const clearUpdateBillingPlanPaypal = () => dispatch => {
  dispatch({
    type: CLEAR_UPDATE_BILLING_PLAN_PAYPAL,
  });
};

export const updateBillingPlanCryptocom = (subscriptionData, planId, interval) => baseErrorsHandlerDecorator(
  UPDATE_BILLING_PLAN_CRYPTOCOM,
  UPDATE_BILLING_PLAN_CRYPTOCOM_ERROR,
  () => restapi.post(addLang('billing/cryptocom/'), {
    subscription_data: subscriptionData,
    billing_plan_id: planId,
    interval: interval,
  }),
);

export const clearUpdateBillingPlanCryptocom = () => dispatch => {
  dispatch({
    type: CLEAR_UPDATE_BILLING_PLAN_CRYPTOCOM,
  });
};

export const cancelSubscription = paymentMethod => baseErrorsHandlerDecorator(
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_ERROR,
  () => restapi.delete(addLang(
    `billing/${paymentMethod === 'paypal' ? 'paypal/' : ''}`
  )),
);

export const clearCancelSubscription = () => dispatch => {
  dispatch({
    type: CLEAR_CANCEL_SUBSCRIPTION,
  });
};

export const renewSubscription = (planId, paymentMethod) => baseErrorsHandlerDecorator(
  RENEW_SUBSCRIPTION,
  RENEW_SUBSCRIPTION_ERROR,
  () => restapi.post(addLang(
    `billing/${paymentMethod === 'paypal' ? 'paypal/' : ''}`
  ), {
    billing_plan_id: planId,
    renew: true,
  }),
);

export const clearRenewSubscription = () => dispatch => {
  dispatch({
    type: CLEAR_RENEW_SUBSCRIPTION,
  });
};

export const fetchCreditCardInfo = () => baseErrorsHandlerDecorator(
  FETCH_CREDIT_CARD_INFO,
  FETCH_CREDIT_CARD_INFO_ERROR,
  () => restapi.get(addLang('billing/stripe/credit-card/')),
  false,
);

export const clearFetchCreditCardInfo = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_CREDIT_CARD_INFO,
  });
};

export const updateCreditCard = paymentMethod => baseErrorsHandlerDecorator(
  UPDATE_CREDIT_CARD,
  UPDATE_CREDIT_CARD_ERROR,
  () => restapi.post(addLang('billing/stripe/credit-card/'), {
    payment_method: paymentMethod,
  }),
);

export const clearUpdateCreditCard = () => dispatch => {
  dispatch({
    type: CLEAR_UPDATE_CREDIT_CARD,
  });
};

export const validateStripeCoupon = (couponValue, planId, interval) => baseErrorsHandlerDecorator(
  VALIDATE_STRIPE_COUPON_SUCCES,
  VALIDATE_STRIPE_COUPON_ERROR,
  () => restapi.get(addLang(
    `billing/stripe/coupon/${couponValue}/${planId}/${interval}/`
  )),
  false,
);

export const clearValidateStripeCoupon = () => dispatch => {
  dispatch({
    type: CLEAR_VALIDATE_STRIPE_COUPON,
  });
};

export const setBillinPlanSelectorMode = mode => dispatch => {
  dispatch({
    type: SET_BILLING_PLAN_SELECTOR_MODE,
    payload: {
      data: mode,
    },
  });
};

export const fetchBillingInvoices = () => baseErrorsHandlerDecorator(
  FETCH_BILLING_INVOICES,
  FETCH_BILLING_INVOICES_ERROR,
  () => restapi.get(addLang('billing/invoices/')),
  false,
);

export const clearFetchBillingInvoices = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_BILLING_INVOICES,
  });
};

export const fetchSingleInvoicePdf = invoiceId => baseErrorsHandlerDecorator(
  FETCH_SINGLE_INVOICE_PDF,
  FETCH_SINGLE_INVOICE_PDF_ERROR,
  () => restapi.get(addLang(`billing/invoices/${invoiceId}/pdf/`)),
  false,
);

export const clearFetchSingleInvoicePdf = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_SINGLE_INVOICE_PDF,
  });
};

export const fetchBillingInfo = () => baseErrorsHandlerDecorator(
  FETCH_BILLING_INFO,
  FETCH_BILLING_INFO_ERROR,
  () => restapi.get(addLang('billing/billing-info/')),
  false,
);

export const clearFetchBillingInfo = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_BILLING_INFO,
  });
};

export const patchBillingInfo = formData => baseErrorsHandlerDecorator(
  PATCH_BILLING_INFO_SUCCESS,
  PATCH_BILLING_INFO_ERROR,
  () => restapi.patch(addLang('billing/billing-info/'), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchBillingInfo = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_BILLING_INFO,
  });
};

export const deletePaymentProvider = id => baseErrorsHandlerDecorator(
  DELETE_PAYMENT_PROVIDER_SUCCESS,
  DELETE_PAYMENT_PROVIDER_ERROR,
  () => restapi.delete(addLang(`billing/payment-providers/${id}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeletePaymentProvider = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_PAYMENT_PROVIDER,
  });
};

export const patchPaymentProvider = (id, formData) => baseErrorsHandlerDecorator(
  PATCH_PAYMENT_PROVIDER_SUCCESS,
  PATCH_PAYMENT_PROVIDER_ERROR,
  () => restapi.patch(addLang(`billing/payment-providers/${id}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchPaymentProvider = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_PAYMENT_PROVIDER,
  });
};

export const fetchPaymentProviderOnboardingLink = (id) => baseErrorsHandlerDecorator(
  FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK,
  FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK_ERROR,
  () => restapi.get(addLang(`billing/payment-providers/onboarding-link/${id}/`)),
  false,
  true /* actionSucces */,
);

export const clearPaymentProviderOnboardingLink = () => dispatch => {
  dispatch({
    type: CLEAR_PAYMENT_PROVIDER_ONBOARDING_LINK,
  });
};
